/**
 * ATTENTION! This file is auto-generated for the 'notifications' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { NotificationRepository } from '../server/repositories/NotificationRepository';
import type { PushSubscriptionRepository } from '../server/repositories/PushSubscriptionRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","meta","getInstance","columns","filters"];

type NotificationRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<NotificationRepository>;
export function useNotificationRepository(): NotificationRepositoryClient { return makeRepositoryProxy<NotificationRepositoryClient>('notifications::NotificationRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useNotificationRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const notificationRepository = useNotificationRepository();

type PushSubscriptionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PushSubscriptionRepository>;
export function usePushSubscriptionRepository(): PushSubscriptionRepositoryClient { return makeRepositoryProxy<PushSubscriptionRepositoryClient>('notifications::PushSubscriptionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePushSubscriptionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const pushSubscriptionRepository = usePushSubscriptionRepository();

type getVapidPublicKeyType = typeof import('../server/functions/getVapidPublicKey').getVapidPublicKey;
export const getVapidPublicKey: RpcFunctionClient<getVapidPublicKeyType> = makeFunctionProxy<getVapidPublicKeyType>('notifications::getVapidPublicKey');

type sendTestPushType = typeof import('../server/functions/sendTestPush').sendTestPush;
export const sendTestPush: RpcFunctionClient<sendTestPushType> = makeFunctionProxy<sendTestPushType>('notifications::sendTestPush');
